/**
 * 전체화면 활성
 *
 * @returns {Promise<boolean>} 성공 여부
 */
export const enableFullScreen = async (): Promise<boolean> => {
    try {
        if (!document.fullscreenElement) {
            await document.documentElement.requestFullscreen();
        }
        return true;
    } catch (error) {
        console.error('전체화면 오류: ', error);
        return false;
    }
};

/**
 * 전체화면 해제
 *
 * @returns {Promise<boolean>} 성공 여부
 */
export const disableFullScreen = async (): Promise<boolean> => {
    try {
        if (document.fullscreenElement) {
            await document.exitFullscreen();
        }
        return true;
    } catch (error) {
        console.error('전체화면 해제 오류: ', error);
        return false;
    }
};

/**
 * 뒤로가기
 */
export const historyBack = () => {
    window.history.back();
};

/**
 * 공통 버튼 색상
 *
 * @param value
 */
export const getTypeColor = (value: number) => {
    const colors = {
        1: 'success',
        0: 'dark',
        [-1]: 'warning',
        [-2]: 'danger',
        [-3]: 'outline',
    };
    return colors[value] || 'default';
};

/**
 * 예문 텍스트의 마크업을 HTML로 변환
 * *텍스트* → <strong>텍스트</strong> (bold)
 *
 * @param text 변환할 텍스트
 * @returns HTML로 변환된 텍스트
 */
export const formatExampleText = (text: string): string => {
    if (!text) return '';

    // XSS 방지를 위해 HTML 특수문자 이스케이프
    let escaped = text
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');

    // *텍스트* → <strong>텍스트</strong>
    escaped = escaped.replace(/\*((?!\s)[^*]+(?<!\s))\*/g, '<strong><u>$1</u></strong>');

    return escaped;
};